import axios from 'axios';

const API_URL = 'https://api.paragaia.tn/user';

// Registration
export const registerUser = (userData) => {
  return axios.post(`${API_URL}/register`, userData);
};

// Login with Email/Password
export const loginUser = (userData) => {
  return axios.post(`${API_URL}/login`, userData);
};

// Login with Google
export const googleLoginUser = (userData) => {
  return axios.post(`${API_URL}/google-login`, userData);
};

// Check if email exists and if it's a password-based account
export const checkEmailForPasswordReset = (email) => {
  return axios.post(`${API_URL}/check-email`, { email });
};

// Send OTP code for password reset
export const sendOtpCode = (email) => {
  return axios.post(`${API_URL}/send-otp`, { email });
};

// Verify OTP code
export const verifyOtpCode = (email, otp) => {
  return axios.post(`${API_URL}/verify-otp`, { email, otp });
};

// Reset password after OTP verification
export const resetPassword = (email, newPassword) => {
  return axios.post(`${API_URL}/reset-password`, { email, newPassword });
};

export const logoutUser = () => {
  return axios.post(`${API_URL}/logout`, {}, { withCredentials: true });
};
